import produce from "immer";
import React, { ChangeEventHandler, FC } from "react";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";


export interface RemarkPropertiesProps {
    element: Element;
}

const RemarkProperties:FC<RemarkPropertiesProps>=({ element }) =>{
  const dispatch = useDispatch();

    return(
        <div className="container pt-3 btn-theam pb-2">
            {/* <div className="card">
                <div className="card-header" id="remarkProperties">
                    <h5 className="mb-0">
                        <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#remark-prop" aria-expanded="false" aria-controls="remark-prop">Remark</button>
                    </h5>
                </div>
                <div id="remark-prop" className="collapse" aria-labelledby="remarkProperties">
                    <div className="card-body"> */}
                        <div className="form-group row">
                            <label htmlFor="remark1" className="col-sm-4 col-form-label font-size-12 align-text-left">
                              Remark - 1
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                className="form-control theam-textbox items-align-left"
                                placeholder="Enter Remark"
                                id="remark1"
                                value={element.properties.remark1}
                                onChange={(e) => {
                                  const newElement = produce(element, draft => { draft.properties.remark1 = e.target.value})
                                  dispatch(startEditElement(newElement));
                                }}
                              />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="remark2" className="col-sm-4 col-form-label font-size-12 align-text-left">
                              Remark - 2
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                className="form-control theam-textbox items-align-left"
                                placeholder="Enter Remark"
                                id="remark2"
                                value={element.properties.remark2}
                                onChange={(e) => {
                                  const newElement = produce(element, draft => { draft.properties.remark2 = e.target.value})
                                  dispatch(startEditElement(newElement));
                                }}
                              />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="remark3" className="col-sm-4 col-form-label font-size-12 align-text-left">
                              Remark - 3
                            </label>
                            <div className="col-sm-8">
                                <textarea className="form-control theam-textbox font-size-12 items-align-left" name="remark3" id="remark3" placeholder="Enter Remark" cols={30} rows={10}
                                value={element.properties.remark3}
                                onChange={(e) => {
                                  const newElement = produce(element, draft => { draft.properties.remark3 = e.target.value})
                                  dispatch(startEditElement(newElement));
                                }}
                                ></textarea>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="remark4" className="col-sm-4 col-form-label font-size-12 align-text-left">
                              Remark - 4
                            </label>
                            <div className="col-sm-8">
                                <textarea className="form-control theam-textbox font-size-12 items-align-left" name="remark4" id="remark4" placeholder="Enter Remark" cols={30} rows={10}
                                value={element.properties.remark4}
                                onChange={(e) => {
                                  const newElement = produce(element, draft => { draft.properties.remark4 = e.target.value})
                                  dispatch(startEditElement(newElement));
                                }}
                                ></textarea>
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div> */}
        </div>
    )
}

export default RemarkProperties;
